import React, { useState, useEffect } from 'react'
import styles from './CookieBanner.module.css'
import useCheckIsMobileScreen from '../../hooks/checkMobileScreen'
import {
  hasUserMadeChoice,
  acceptAllCookies,
  declineAllCookies,
  initializeConsentMode
} from '../../utils/cookieConsent'

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)
  const { isMobile } = useCheckIsMobileScreen()

  useEffect(() => {
    initializeConsentMode()

    if (!hasUserMadeChoice()) {
      // Small delay to ensure page has loaded
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 1000)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleAccept = () => {
    acceptAllCookies()
    setIsVisible(false)
  }

  const handleDecline = () => {
    declineAllCookies()
    setIsVisible(false)
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className={styles.cookieBanner}>
      {isMobile ? (
        <div className={styles.mobileDescriptionContainer}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className={styles.title}>🍪 We use cookies</div>
            <button className={styles.learnMoreButton} onClick={toggleExpanded} type="button">
              Learn more <span style={{ fontSize: '0.8em' }}>{isExpanded ? '▲' : '▼'}</span>
            </button>
          </div>
          {isExpanded && (
            <div className={styles.expandedDescription}>
              <div className={styles.description}>
                We use cookies to enhance your experience, analyze site traffic, and for marketing purposes. You can
                manage your preferences or learn more in our{' '}
                <a href="https://tiiny.host/privacypolicy.html" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
                .
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
          <div className={styles.title}>🍪 We use cookies</div>
          <div className={styles.description}>
            We use cookies to enhance your experience, analyze site traffic, and for marketing purposes. You can manage
            your preferences or learn more in our{' '}
            <a href="https://tiiny.host/privacypolicy.html" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            .
          </div>
        </>
      )}
      <div className={styles.buttonContainer}>
        <button className={`${styles.button} ${styles.declineButton}`} onClick={handleDecline} type="button">
          Decline
        </button>

        <button className={`${styles.button} ${styles.acceptButton}`} onClick={handleAccept} type="button">
          Accept All
        </button>
      </div>
    </div>
  )
}

export default CookieBanner
